module.exports = __webpack_public_path__ + "img/weixinpay@2x.43e17e81.png";